if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

          // console.log('hihih get cart');
          //Ak custom code
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('cart.item_count',cart.item_count);
          });
          
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              console.log('cart.item_count', cart.item_count);
          
              const cookieName = 'package_protection_added';
              const currentCookie = getCookie(cookieName);
          
              if (cart.item_count === 0) {
                // document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                // console.log('Cookie removed because cart is empty');
              } else if (cart.item_count > 0 && !currentCookie) {
                const checkbox = document.querySelector('.so-package-protection-add-remove'); // update selector if needed
          
                if (checkbox && !checkbox.checked) {
                  checkbox.checked = true;
                  // Manually dispatch change event
                  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                }
          
                setCookie(cookieName, 'added', 7);
                // console.log('Cookie set');
              } else {
                console.log('No action taken: cookie exists or cart is empty');
              }
            });
          
          // Helper to get cookie
          function getCookie(name) {
            const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : null;
          }
          
          // Helper to set cookie
          function setCookie(name, value, days) {
            const expires = new Date();
            expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = name + '=' + value + '; expires=' + expires.toUTCString() + '; path=/';
          }


          //End Ak custom code

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);


                    //AK custom code
                      var free_gift_id = document.body.getAttribute('data-free-gift-id');
                      var free_gift__price = document.body.getAttribute('data-free-gift-price');
                      
                      if(free_gift_id) {
                          fetch('/cart.js')
                              .then(response => response.json())
                              .then(cart => {
                                  let cartData = cart.items;
                                  console.log('length', cartData.length);
                      
                                  if(cartData.length == 1) {
                                      var item_contain = false;
                                      for(var i = 0; i < cartData.length; i++) {
                                          if(cartData[i].id == free_gift_id) {
                                              item_contain = true;
                                              break;
                                          }
                                      }
                      
                                      if(!item_contain) {
                                          if(cart.total_price > free_gift__price) {
                                              var updates = {
                                                  updates: {}
                                              };
                                              updates['updates'][free_gift_id] = 1;
                      
                                              fetch('/cart/update.js', {
                                                  method: 'POST',
                                                  headers: {
                                                      'Content-Type': 'application/json'
                                                  },
                                                  body: JSON.stringify(updates)
                                              })
                                              .then(response => response.json())
                                              .then(data => {
                                                  console.log('tytytytyty');
                                                    //update function
                                                   window.refreshCart();
                                                    // fetch(window.location.href, {
                                                    //     method: "GET"
                                                    // })
                                                    // .then(response => response.text())
                                                    // .then(htmlContent => {
                                                    //       const sectionInnerHTML = new DOMParser().parseFromString(htmlContent, 'text/html');
                                                    //       const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                                    //       const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                      
                                                    //       const cartItems = document.getElementById('AjaxCartForm');
                                                    //       cartItems.innerHTML = cartFormInnerHTML;
                                                    //       cartItems.ajaxifyCartItems();
                                      
                                                    //       // if ( alert != '' ) {
                                                    //       //     document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
                                                    //       // }
                                      
                                                    //       document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                      
                                                    //       document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                                    //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                                                    //       });
                                                    //       document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                                    //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                                                    //       });
                                                    //       // this.dispatchEvent(this.ADD_TO_CART);
                                      
                                                    //       // a11y
                                                    //       if ( document.getElementById('screen-reader-info') ) {
                                                    //           document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
                                                    //           setTimeout(()=>{
                                                    //               document.getElementById('screen-reader-info').innerText = '';
                                                    //           }, 1000);
                                                    //       }
                                                    // })
                                                    // .catch(error => {
                                                    //     console.error("Error fetching and modifying HTML:", error);
                                                    // });
                                                    //update function
                                              })
                                              .catch(error => {
                                                  console.error(error);
                                              });
                                          }
                                      } else {
                                          var updates = {
                                              updates: {}
                                          };
                                          updates['updates'][free_gift_id] = 0;
                      
                                          fetch('/cart/update.js', {
                                              method: 'POST',
                                              headers: {
                                                  'Content-Type': 'application/json'
                                              },
                                              body: JSON.stringify(updates)
                                          })
                                          .then(response => response.json())
                                          .then(data => {
                                              console.log('tytytytyty');
                                              //update function
                                               window.refreshCart();
                                              // fetch(window.location.href, {
                                              //     method: "GET"
                                              // })
                                              // .then(response => response.text())
                                              // .then(htmlContent => {
                                              //       const sectionInnerHTML = new DOMParser().parseFromString(htmlContent, 'text/html');
                                              //       const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                              //       const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                
                                              //       const cartItems = document.getElementById('AjaxCartForm');
                                              //       cartItems.innerHTML = cartFormInnerHTML;
                                              //       cartItems.ajaxifyCartItems();
                                
                                              //       // if ( alert != '' ) {
                                              //       //     document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
                                              //       // }
                                
                                              //       document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                
                                              //       document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                              //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                                              //       });
                                              //       document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                              //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                                              //       });
                                              //       // this.dispatchEvent(this.ADD_TO_CART);
                                
                                              //       // a11y
                                              //       if ( document.getElementById('screen-reader-info') ) {
                                              //           document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
                                              //           setTimeout(()=>{
                                              //               document.getElementById('screen-reader-info').innerText = '';
                                              //           }, 1000);
                                              //       }
                                              // })
                                              // .catch(error => {
                                              //     console.error("Error fetching and modifying HTML:", error);
                                              // });
                                              //update function
                                          })
                                          .catch(error => {
                                              console.error(error);
                                          });
                                      }
                      
                                  } else if(cartData.length > 1) {
                                      var item_contain = false;
                      
                                      for(var i = 0; i < cartData.length; i++) {
                                          if(cartData[i].id == free_gift_id) {
                                              item_contain = true;
                                              break;
                                          }
                                      }
                      
                                      if(!item_contain) {
                                          if(cart.total_price > free_gift__price) {
                                              var updates = {
                                                  updates: {}
                                              };
                                              updates['updates'][free_gift_id] = 1;
                      
                                              fetch('/cart/update.js', {
                                                  method: 'POST',
                                                  headers: {
                                                      'Content-Type': 'application/json'
                                                  },
                                                  body: JSON.stringify(updates)
                                              })
                                              .then(response => response.json())
                                              .then(data => {
                                                  console.log('tytytytyty');
                                                 //update function
                                                 window.refreshCart();
                                                  // fetch(window.location.href, {
                                                  //     method: "GET"
                                                  // })
                                                  // .then(response => response.text())
                                                  // .then(htmlContent => {
                                                  //       const sectionInnerHTML = new DOMParser().parseFromString(htmlContent, 'text/html');
                                                  //       const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                                  //       const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                    
                                                  //       const cartItems = document.getElementById('AjaxCartForm');
                                                  //       cartItems.innerHTML = cartFormInnerHTML;
                                                  //       cartItems.ajaxifyCartItems();
                                    
                                                  //       // if ( alert != '' ) {
                                                  //       //     document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
                                                  //       // }
                                    
                                                  //       document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                    
                                                  //       document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                                  //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                                                  //       });
                                                  //       document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                                  //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                                                  //       });
                                                  //       // this.dispatchEvent(this.ADD_TO_CART);
                                    
                                                  //       // a11y
                                                  //       if ( document.getElementById('screen-reader-info') ) {
                                                  //           document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
                                                  //           setTimeout(()=>{
                                                  //               document.getElementById('screen-reader-info').innerText = '';
                                                  //           }, 1000);
                                                  //       }
                                                  // })
                                                  // .catch(error => {
                                                  //     console.error("Error fetching and modifying HTML:", error);
                                                  // });
                                                  //update function
                                              })
                                              .catch(error => {
                                                  console.error(error);
                                              });
                                          }
                                      } else {
                                          if(cart.total_price < free_gift__price) {
                                              var updates = {
                                                  updates: {}
                                              };
                                              updates['updates'][free_gift_id] = 0;
                      
                                              fetch('/cart/update.js', {
                                                  method: 'POST',
                                                  headers: {
                                                      'Content-Type': 'application/json'
                                                  },
                                                  body: JSON.stringify(updates)
                                              })
                                              .then(response => response.json())
                                              .then(data => {
                                                  console.log('tytytytyty');
                                                 //update function
                                                 window.refreshCart();
                                                  // fetch(window.location.href, {
                                                  //     method: "GET"
                                                  // })
                                                  // .then(response => response.text())
                                                  // .then(htmlContent => {
                                                  //       const sectionInnerHTML = new DOMParser().parseFromString(htmlContent, 'text/html');
                                                  //       const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                                  //       const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                    
                                                  //       const cartItems = document.getElementById('AjaxCartForm');
                                                  //       cartItems.innerHTML = cartFormInnerHTML;
                                                  //       cartItems.ajaxifyCartItems();
                                    
                                                  //       // if ( alert != '' ) {
                                                  //       //     document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
                                                  //       // }
                                    
                                                  //       document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                    
                                                  //       document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                                  //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                                                  //       });
                                                  //       document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                                  //           elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                                                  //       });
                                                  //       // this.dispatchEvent(this.ADD_TO_CART);
                                    
                                                  //       // a11y
                                                  //       if ( document.getElementById('screen-reader-info') ) {
                                                  //           document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
                                                  //           setTimeout(()=>{
                                                  //               document.getElementById('screen-reader-info').innerText = '';
                                                  //           }, 1000);
                                                  //       }
                                                  // })
                                                  // .catch(error => {
                                                  //     console.error("Error fetching and modifying HTML:", error);
                                                  // });
                                                  //update function
                                              })
                                              .catch(error => {
                                                  console.error(error);
                                              });
                                          }
                                      }
                                  }
                              })
                              .catch(error => {
                                  console.error(error);
                              });
                      }

                    var ship_protect_id = document.body.getAttribute('data-ship-protection-id');
                    if(ship_protect_id){
                      console.log('above');
                      check_ship_protect(ship_protect_id);
                    }
                    //end AK Custom code

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

        var ship_protect_id = document.body.getAttribute('data-ship-protection-id');
        if(ship_protect_id){
          console.log('in refresh');
          check_ship_protect(ship_protect_id);
        }

	}

}


//Ak custom code
function check_ship_protect(ship_protect_id){
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    let cartData = cart.items;
    console.log('length', cartData.length);
  
    if(cartData.length == 1) {
      var item_contain = false;
      for(var i = 0; i < cartData.length; i++) {
          if(cartData[i].id == ship_protect_id) {
              item_contain = true;
              break;
          }
      }

      if(item_contain){
        var updates = {
            updates: {}
        };
        updates['updates'][ship_protect_id] = 0;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updates)
        })
        .then(response => response.json())
        .then(data => {
          window.refreshCart();
        })
        .catch(error => {
            console.error(error);
        });
     }
      
    }
  });
}
//End Ak custom code